import { UserAccount } from '@/types/TAccounts';
import { USER_NPS_TRIGGER_STATE } from 'src/enums/EUser';
import { LocalStorageKeys } from 'src/enums/ELocalStorage';
import LocalStorageUtility from './localStorage';
import moment from 'moment';
import { updateUserData } from '@/api/user';
import { USER_TYPES } from 'src/enums/EUser';

const DISMISSAL_COOLDOWN_HOURS = 2;
const MIN_CALLS_FOR_NPS = 10;

export const checkNPSTriggerConditions = (
	userAccount: UserAccount | null,
): USER_NPS_TRIGGER_STATE => {
	const totalCalls = userAccount.totalCalls || 0;

	if (
		!userAccount ||
		userAccount.hasNpsExpired ||
		(userAccount.nps !== null && userAccount.nps !== undefined) ||
		totalCalls < MIN_CALLS_FOR_NPS
	) {
		return USER_NPS_TRIGGER_STATE.HIDE;
	}

	const dismissedAt = LocalStorageUtility.getLocalData<string>(LocalStorageKeys.NPS_DISMISSED_AT);
	const firstDismissedAt = LocalStorageUtility.getLocalData<string>(
		LocalStorageKeys.NPS_FIRST_DISMISSED_AT,
	);

	if (dismissedAt) {
		const dismissalMoment = moment(dismissedAt);
		const firstDismissalMoment = moment(firstDismissedAt);
		const now = moment();
		const differenceInHours = now.diff(dismissalMoment, 'hours');
		const differenceInDays = now.diff(firstDismissalMoment, 'days');

		if (differenceInDays >= 7) {
			updateUserData({
				clientType: USER_TYPES.CLIENT,
				data: { hasNpsExpired: true },
			}).catch(() => {
				return USER_NPS_TRIGGER_STATE.HIDE;
			});

			return USER_NPS_TRIGGER_STATE.HIDE;
		}

		if (differenceInHours < DISMISSAL_COOLDOWN_HOURS) {
			return USER_NPS_TRIGGER_STATE.SHOW_COLLAPSED;
		}
	}
	return USER_NPS_TRIGGER_STATE.SHOW_EXPANDED;
};

export const markNPSAsDismissed = (): void => {
	LocalStorageUtility.setLocalData(LocalStorageKeys.NPS_DISMISSED_AT, new Date().toISOString());

	const existingFirstDismissal = LocalStorageUtility.getLocalData<string>(
		LocalStorageKeys.NPS_FIRST_DISMISSED_AT,
	);
	if (!existingFirstDismissal) {
		LocalStorageUtility.setLocalData(
			LocalStorageKeys.NPS_FIRST_DISMISSED_AT,
			new Date().toISOString(),
		);
	}
};

export const clearNPSDismissal = (): void => {
	LocalStorageUtility.removeLocalData(LocalStorageKeys.NPS_DISMISSED_AT);
	LocalStorageUtility.removeLocalData(LocalStorageKeys.NPS_FIRST_DISMISSED_AT);
};
